module.exports = __webpack_public_path__ + "static/media/logo-highest-res.61d6f867.png";